import React, { useEffect, useState } from 'react';
import { saveNewAdvice } from '../../API/advices';
import { Button, Form, Modal } from 'react-bootstrap';
import { Check, Save, X } from 'react-feather';
import '../../Styles/Annotator/AdvicesComponent.css';
import uuid from 'react-uuid';

function CreateAdviceComponent() {
    const [createAdviceSaveConfirmationModalShow, setCreateAdviceSaveConfirmationModalShow] = useState(false);
    const [createAdviceSaveData, setCreateAdviceSaveData] = useState({});
    const [createAdviceData, setCreateAdviceData] = useState({
        o: {uidid:'',
            advice: '',
            anspruch: '',
            category: 'Hinweis',
            pcategories: [],
            formel: '',
            kommentor: '',
            norm: ''
        }
    });

    useEffect(() => {
        console.log('...' + createAdviceData.o);
    }, []);

    /**
     * This function handles the maintenance of new advice data for API.
     */
    function handleSave() {
        setCreateAdviceSaveConfirmationModalShow(true);

        // Prepare data for save new advice - API

        // Capture the values of edit advice
        // const uidid = uuid(); :: API do not accept new ID from frontend.
        // :: Refer - https://handwai.atlassian.net/wiki/spaces/HAI/pages/2601288007/Annotator+-+Code
        //const uidid = this.state.createAdviceData.o.uidid;
        const new_advice = createAdviceData.o.advice.replace(/\n/g, '');
        const new_category = createAdviceData.o.category;
        const new_pcategories= [];
        const new_kommentor = createAdviceData.o.kommentor.replace(/\n/g, '');
        const new_norm = createAdviceData.o.norm.replace(/\n/g, '');
        const new_formula = createAdviceData.o.formel.replace(/\n/g, '');
        const new_anspruch = createAdviceData.o.anspruch.replace(/\n/g, '');

        let processedNewAdviceDataForAPI =
            {
                'uidid': uuid(),
                'advice':
                    new_advice.toString(),
                'anspruch':
                    new_anspruch.toString(),
                'category':
                    new_category.toString(),
                'pcategories':
                    new_pcategories,
                'formel':
                    new_formula.toString(),
                'kommentor':
                    new_kommentor.toString(),
                'norm':
                    new_norm.toString()
            };

        setCreateAdviceSaveData(processedNewAdviceDataForAPI);
    }

    /**
     * This function closes the Save confirmation model and calls API to save new advice.
     */
    async function handleSaveConfirmationClick() {
        setCreateAdviceSaveConfirmationModalShow(false);
        await saveNewAdvice(createAdviceSaveData); //  API call
        // To actualise the change
        window.location.reload();
    }

    /**
     * This function handles the new changes made for Advice in New Advice Form.
     * @param newChangeData
     */
    function handleAdviceChange(newChangeData) {
        let createAdviceDataCopy = JSON.parse(JSON.stringify(createAdviceData));
        createAdviceDataCopy.o.advice = newChangeData;
        setCreateAdviceData(createAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Category change in New Advice Form.
     * @param newChangeData
     */
    function handleCategoryChange(newChangeData) {
        let createAdviceDataCopy = JSON.parse(JSON.stringify(createAdviceData));
        createAdviceDataCopy.o.category = newChangeData;
        setCreateAdviceData(createAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Comments in New Advice Form.
     * @param newChangeData
     */
    function handleKommentorChange(newChangeData) {
        let createAdviceDataCopy = JSON.parse(JSON.stringify(createAdviceData));
        createAdviceDataCopy.o.kommentor = newChangeData;
        setCreateAdviceData(createAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Norm in New Advice Form.
     * @param newChangeData
     */
    function handleNormChange(newChangeData) {
        let createAdviceDataCopy = JSON.parse(JSON.stringify(createAdviceData));
        createAdviceDataCopy.o.norm = newChangeData;
        setCreateAdviceData(createAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Formel in New Advice Form.
     * @param newChangeData
     */
    function handleFormelChange(newChangeData) {
        let createAdviceDataCopy = JSON.parse(JSON.stringify(createAdviceData));
        createAdviceDataCopy.o.formel = newChangeData;
        setCreateAdviceData(createAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Anspruch in New Advice Form.
     * @param newChangeData
     */
    function handleAnspruchChange(newChangeData) {
        let createAdviceDataCopy = JSON.parse(JSON.stringify(createAdviceData));
        createAdviceDataCopy.o.anspruch = newChangeData;
        setCreateAdviceData(createAdviceDataCopy);
    }

    return (
        <>
            <Form id="formID">
                <Form.Group controlId="formCreateAdviceID">
                    <Form.Label>Advice</Form.Label>
                    <Form.Control
                        as="textarea"
                        placeholder="new_advice_placeholder"
                        defaultValue={createAdviceData.o.advice}
                        onChange={(event) => handleAdviceChange(event.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="formCreateCategoryID">
                    <Form.Label>Category</Form.Label>
                    <Form.Control
                        as="select"
                        placeholder="new_category_placeholder"
                        defaultValue={createAdviceData.o.category}
                        onChange={(event) => handleCategoryChange(event.target.value)}
                    >
                        <option selected>Hinweis</option>
                        <option>Potenzial</option>
                        <option>Risiko</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group controlId="formCreateKommentorID">
                    <Form.Label>Kommentar</Form.Label>
                    <Form.Control
                        as="textarea"
                        className="form-control"
                        placeholder="new_kommentor_placeholder"
                        defaultValue={createAdviceData.o.kommentor}
                        onChange={(event) => handleKommentorChange(event.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="formCreateNormID">
                    <Form.Label>AI-Tag</Form.Label>
                    <Form.Control
                        as="textarea"
                        placeholder="AI-Tag_placeholder"
                        defaultValue={createAdviceData.o.norm}
                        onChange={(event) => handleNormChange(event.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="formCreateFormelID">
                    <Form.Label>Formel</Form.Label>
                    <Form.Control
                        as="textarea"
                        placeholder="new_formel_placeholder"
                        defaultValue={createAdviceData.o.formel}
                        onChange={(event) => handleFormelChange(event.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="formCreateAnspruchID">
                    <Form.Label>Anspruch</Form.Label>
                    <Form.Control
                        as="textarea"
                        placeholder="new_anspruch_placeholder"
                        defaultValue={createAdviceData.o.anspruch}
                        onChange={(event) => handleAnspruchChange(event.target.value)}
                    />
                </Form.Group>
                <Button size="lg" block variant="outline-success" onClick={() => handleSave()}>
                    <Save />
                    Speichern
                </Button>
            </Form>

            <Modal
                show={createAdviceSaveConfirmationModalShow}
                onHide={() => setCreateAdviceSaveConfirmationModalShow(false)}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Bitte bestätigen Sie</Modal.Title>
                </Modal.Header>
                <Modal.Body>Möchten Sie die neue Advice wirklich speichern? </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-success" onClick={() => handleSaveConfirmationClick()}>
                        <Check />
                        Ja! Ich bestätige.
                    </Button>
                    <Button variant="outline-dark" onClick={() => setCreateAdviceSaveConfirmationModalShow(false)}>
                        <X />
                        Nein
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CreateAdviceComponent;
